// extracted by mini-css-extract-plugin
export default {"container":"ProtectedRoute_container__JVh4p","title":"ProtectedRoute_title__Hjlza","link":"ProtectedRoute_link__6mE4e","text":"ProtectedRoute_text__ICTux"};